import Axios from 'axios';
import { Toast } from 'vant';
// import qs from 'qs';
import md5 from "md5";
import * as _localStorage from '@/utils/storage';
// 接口前缀
function getHeaders() {
  const davinciKey = "davinci.xiaoyibang";
  const nonceStr = new Date().getTime() % 100000;
  const sign = md5(nonceStr + davinciKey);
  return { sign, nonceStr };
}
// axios 配置实例
const getAxiosInstance = () => {
  const instance = Axios.create();
  const customHeaders = getHeaders();
  instance.defaults.headers = {
    'X-Requested-With': 'XMLHttpRequest',
    ...customHeaders
  };
  instance.defaults.timeout = 15000;
  instance.interceptors.request.use(config => {
    const collegeId = _localStorage.getStorageSync('collegeId') || ''
    config.headers = {
      ...config.headers,
      collegeId
    }
    return {
      ...config,
      params: {
        // 此处注意，你的`params`应该是个对象，不能是其他数据类型
        ...(config.params || {})
        // ts: +new Date()
      }
    };
  });
  instance.interceptors.response.use(
    response => {
      if (response && response.data) {
        let msg = response.data.info || response.data.msg || response.data.message;
        if (response.data.code == 200) {
          return Promise.resolve(response.data);
        } else if (response.data.code == '000') {
          return Promise.reject(response);
        } else if (response.data.code == 500) {
          Toast(response.data.message);
          return Promise.reject(response);
        } else if (response.data.code == 400) {
          Toast(response.data.message);
          return Promise.reject(response);
        } else if (response.data.code == 401) {
          Toast(response.data.message);
          return Promise.reject(response);
        } else if (response.header.filecode == '10200') {
          return Promise.resolve(response);
        } else {
          Toast(msg)
          return Promise.reject(response);
        }
      } else {
        return Promise.reject('response 不存在');
      }
    },
    error => {
      console.log('-- error --');
      console.log(error);
      console.log('-- error --');
      Toast('请求超时！');
      return Promise.reject({
        msg: error
      });
    }
  );
  return instance;
};

// function getLang(str, opt) {
//   let map = {
//     'Unknown method': '该接口不存在【' + opt.method + ' ' + opt.url + '】'
//   };
//   if (map[str]) {
//     return map[str];
//   } else {
//     return '';
//   }
// }
// 获取一个 Ajax 实例
const GetAxios = () => {
  const instance = getAxiosInstance();
  const request = config => {
    return new Promise((resolve, reject) => {
      instance
        .request(config)
        .then(data => {
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  };

  // Ajax 实体
  const Ajax = {
    get: function(url, data = {}, config = {}) {
      return request(
        Object.assign({}, config, {
          method: 'GET',
          url: url,
          params: data
        })
      );
    },
    del: function(url, data = {}, config = {}) {
      return request(
        Object.assign({}, config, {
          method: 'DELETE',
          url: url,
          params: data
        })
      );
    },
    post: function(url, data = {}, config = {}) {
      return request(
        Object.assign({}, config, {
          method: 'POST',
          url: url,
          data: data
        })
      );
    },
    put: function(url, data = {}, config = {}) {
      return request(
        Object.assign({}, config, {
          method: 'PUT',
          url: url,
          data: data
        })
      );
    },
    head: function(url, config = {}) {
      return request(
        Object.assign({}, config, {
          method: 'HEAD',
          url: url
        })
      );
    },
    options: function(url, config = {}) {
      return request(
        Object.assign({}, config, {
          method: 'OPTIONS',
          url: url
        })
      );
    },
    patch: function(url, data = {}, config = {}) {
      return request(
        Object.assign({}, config, {
          method: 'PATCH',
          url: url,
          data: data
        })
      );
    }
  };

  return Ajax;
};

export const Ajax = GetAxios();
export default GetAxios;
